export const ajaxFetch = (uri, {headers, ...params} = {}) =>
    fetch(`${uri}`, {
        headers: {'X-Requested-With': 'XMLHttpRequest', ...headers},
        credentials: 'same-origin',
        ...params
    });

export const fetchJSON = (...args) => ajaxFetch(...args).then(r => r.json());
